import React, {useEffect, useRef, useState} from 'react'
import {apiConstants, post, get, postMultipart, getDownload} from '../../../../common/constants'
import '../location.css'
import AddDeliveryLocation from './addDeliveryLocation'
import Loader from '../../../../common/Loader'
import {Button, Chip, IconButton, Tooltip, Typography} from '@mui/material'
import {Box} from '@mui/material'
import ProzoDataGrid from '../../../../common/ProzoDataGrid'
import {useSnackbar} from 'notistack'
import {AddCircleRounded, DownloadRounded, Edit, UploadFileRounded} from '@mui/icons-material'
import {getMerchant} from '../../../../helpers/ReduxHelpers'
import withLayout from '../../../../hocs/Layout'
import {findInObjArr} from '../../../../helpers/UtilityHelper'
import PageTitle from '../../../../common/PageTitle'
import PageHero from '../../../../common/PageHero'
import {FilterLocation} from '../Filter'
import {pageContainerSx, primaryBtnSx, secondaryBtnSx} from '../../../../styles/patterns'
import {primaryTextSx, secondaryTextSx, cellStackSx} from '../../../orders/list2/cellStyles'
import {SUCCESS, ERROR} from '../../../../styles/foundation/colors'

function MerchantDeliveryLocations() {
  const [show, setShow] = useState(false)
  const [formLoading, setFormLoading] = useState(false)
  const [deliveryLocation, setDelLocation] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentId, setCurrentId] = useState()
  const [page, setPage] = useState(0)
  const [sizePerPage, setSizePerPage] = useState(10)
  const [filteredLocationList, setFilteredLocationList] = useState([])
  const bulkUploadRef = useRef()

  const {enqueueSnackbar} = useSnackbar()

  const handleClose = () => {
    setShow(false)
    setCurrentId(null)
  }

  const handleShow = () => setShow(true)

  const merchant = getMerchant()
  const merchantId = merchant.id ? merchant.id : ''

  const handleSubmit = (param) => {
    setFormLoading(true)
    const addressCopy = Object.assign(
      {},
      {status: 'ACTIVE', address_type: 'PICKUP', country: 'India'},
      currentId,
      param
    )
    post(
      `${apiConstants.BASE_LOCAL}${apiConstants.ADD_DELIVERY_LOCATIONS}/${merchantId}`,
      addressCopy
    )
      .then((response) => {
        setFormLoading(false)
        handleClose()
        loadLocation()
      })
      .catch((err) => {
        console.error(err)
        setFormLoading(false)
      })
  }

  const loadLocation = () => {
    setLoading(true)
    get(`${apiConstants.BASE_LOCAL}${apiConstants.GET_DELIVERY_LOCATIONS}/${merchantId}`)
      .then((response) => {
        setLoading(false)
        if (response.data && response.data.length > 0) {
          setDelLocation(response.data)
        }
      })
      .catch((err) => {
        console.error(err)
        setLoading(false)
      })
  }

  const handleEditClick = (id) => {
    const result = findInObjArr(deliveryLocation, id, 'id')
    setCurrentId(result)
    handleShow()
  }

  const handleDownloadSampleClick = () => {
    setLoading(true)
    getDownload(
      `${apiConstants.BASE_LOCAL}${apiConstants.DOWNLOAD_SAMPLE_LOCATION}?fileName=BULK_DELIVERY_LOC_UPLOAD`
    )
      .then((response) => {
        setLoading(false)
        const binaryData = []
        binaryData.push(response.data)
        const href = URL.createObjectURL(new Blob(binaryData, {type: 'application/octet-stream'}))
        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', 'delivery-location.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
      })
      .catch((err) => {
        console.error(err)
        setLoading(false)
      })
  }

  const handleBulkUpload = (e) => {
    const param = e.target.files[0]
    const formData = new FormData()
    formData.append('file', param)
    formData.append('fileName', param.name)
    setLoading(true)
    postMultipart(`${apiConstants.UPLOAD_DELIVERY_LOCATIONS}?merchantOid=${merchantId}`, formData)
      .then((response) => {
        setLoading(false)
        loadLocation()
        enqueueSnackbar('Uploaded', {variant: 'success'})
        if (bulkUploadRef.current) {
          bulkUploadRef.current.value = null
        }
      })
      .catch((err) => {
        enqueueSnackbar('Could not be uploaded!', {variant: 'error'})
        setLoading(false)
        if (bulkUploadRef.current) {
          bulkUploadRef.current.value = null
        }
      })
  }

  useEffect(() => {
    loadLocation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFilter = (filterValues) => {
    const {contactNumber, name} = filterValues
    const filteredLocations = deliveryLocation.filter((location) => {
      const matchesContactNumber = contactNumber
        ? location.contactNumber.includes(contactNumber)
        : true
      const matchesName = name ? location.name.toLowerCase().includes(name.toLowerCase()) : true
      return matchesContactNumber && matchesName
    })
    setFilteredLocationList(filteredLocations)
  }

  useEffect(() => {
    setFilteredLocationList(deliveryLocation)
  }, [deliveryLocation])

  const resetFilter = () => {
    setFilteredLocationList(deliveryLocation)
  }

  const getStatusChipSx = (isActive) => {
    const color = isActive ? SUCCESS : ERROR
    return {
      fontWeight: 600,
      fontSize: 11,
      height: 24,
      bgcolor: color + '18',
      color,
      border: `1px solid ${color}40`,
      '& .MuiChip-label': {px: 1},
    }
  }

  return (
    <>
      <PageTitle>Delivery Location</PageTitle>
      {/* <PageHero
        title='Delivery Location'
        subtitle='Manage your delivery and drop-off addresses'
        sx={{mb: 2.5}}
      /> */}
      {loading && <Loader />}
      <input
        type='file'
        onChange={handleBulkUpload}
        ref={bulkUploadRef}
        style={{display: 'none'}}
      />
      <Box sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1, mb: 2}}>
        <Button
          startIcon={<AddCircleRounded />}
          onClick={handleShow}
          sx={primaryBtnSx}
        >
          Add
        </Button>
        <Button
          startIcon={<UploadFileRounded />}
          onClick={() => bulkUploadRef.current.click()}
          sx={secondaryBtnSx}
        >
          Upload
        </Button>
        <Button
          startIcon={<DownloadRounded />}
          onClick={handleDownloadSampleClick}
          sx={secondaryBtnSx}
        >
          Sample Download
        </Button>
      </Box>
      <FilterLocation onFilter={handleFilter} resetFilter={resetFilter} />
      <Box sx={{mt: 2}}>
        <ProzoDataGrid
          rows={filteredLocationList || []}
          getRowId={(row) => row.id}
          sizePerPage={sizePerPage}
          setSizePerPage={setSizePerPage}
          setPage={setPage}
          page={page}
          rowCount={filteredLocationList?.length || 0}
          paginationMode={'client'}
          columns={[
            {
              headerName: 'Name',
              field: 'name',
              flex: 1,
              minWidth: 150,
              renderCell: ({row}) => (
                <Box sx={cellStackSx}>
                  <Typography sx={primaryTextSx}>{row.name || '-'}</Typography>
                </Box>
              ),
            },
            {
              headerName: 'Address',
              field: 'pincode',
              flex: 1.5,
              minWidth: 220,
              renderCell: ({row}) => {
                const addArr = []
                if (row.address_line) addArr.push(row.address_line)
                if (row.city) addArr.push(row.city)
                if (row.state) addArr.push(row.state)
                if (row.pincode) addArr.push(row.pincode)
                if (row.country) addArr.push(row.country)
                const cityState = [row.city, row.state].filter(Boolean).join(', ')
                return (
                  <Box sx={cellStackSx}>
                    <Typography sx={primaryTextSx}>
                      {row.address_line || '-'}
                    </Typography>
                    <Typography sx={secondaryTextSx}>
                      {[cityState, row.pincode].filter(Boolean).join(' - ')}
                    </Typography>
                  </Box>
                )
              },
            },
            {
              headerName: 'Drop Address',
              field: 'dropOrganization',
              flex: 1,
              minWidth: 150,
              renderCell: ({row}) => (
                <Box sx={cellStackSx}>
                  <Typography sx={primaryTextSx}>{row.dropOrganization || '-'}</Typography>
                </Box>
              ),
            },
            {
              headerName: 'Contact No',
              field: 'contactNumber',
              flex: 1,
              minWidth: 130,
              renderCell: ({row}) => (
                <Box sx={cellStackSx}>
                  <Typography sx={primaryTextSx}>{row.contactNumber || '-'}</Typography>
                </Box>
              ),
            },
            {
              headerName: 'Email',
              field: 'email',
              flex: 1,
              minWidth: 180,
              renderCell: ({row}) => (
                <Box sx={cellStackSx}>
                  <Typography sx={secondaryTextSx}>{row.email || '-'}</Typography>
                </Box>
              ),
            },
            {
              headerName: 'GSTIN',
              field: 'gstin',
              flex: 1,
              minWidth: 160,
              renderCell: ({row}) => (
                <Box sx={cellStackSx}>
                  <Typography sx={primaryTextSx}>{row.gstin || '-'}</Typography>
                </Box>
              ),
            },
            {
              headerName: 'Status',
              field: 'status',
              flex: 0.8,
              minWidth: 110,
              renderCell: ({row}) => {
                const isActive = row.status === 'ACTIVE'
                return (
                  <Chip
                    sx={getStatusChipSx(isActive)}
                    label={row.status ? 'ACTIVE' : 'INACTIVE'}
                    size='small'
                  />
                )
              },
            },
            {
              headerName: 'Action',
              field: 'action',
              flex: 0.6,
              minWidth: 80,
              renderCell: ({row}) => {
                return (
                  <Tooltip title='Edit Delivery Location'>
                    <IconButton onClick={() => handleEditClick(row.id)} size='small'>
                      <Edit color='primary' fontSize='small' />
                    </IconButton>
                  </Tooltip>
                )
              },
            },
          ]}
        />
      </Box>
      <AddDeliveryLocation
        show={show}
        formLoading={formLoading}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
        currentId={currentId}
      />
    </>
  )
}

export default withLayout(() => {
  return (
    <Box sx={pageContainerSx}>
      <MerchantDeliveryLocations />
    </Box>
  )
})
